/**
 * Stable id helpers that link a slide (tabpanel) to its dot (tab) for ARIA.
 *
 * These are the single source of truth for the id convention so that
 * server-rendered slides and the client-side dots agree without each side
 * re-deriving the string template. Custom, portal-specific slide markup can
 * import these to stay wired to the shared controls.
 */
export const getSlideId = (idx: number): string => `hero-carousel-slide-${idx + 1}`;
export const getTabId = (idx: number): string => `hero-carousel-tab-${idx + 1}`;
